/** 注册页区号列表（中文展示名），中国大陆固定置顶 */
const OTHERS = [
	// { name: '阿尔及利亚', dial: '+213' },
	// { name: '阿根廷', dial: '+54' },
	// { name: '阿联酋', dial: '+971' },
	// { name: '埃及', dial: '+20' },
	// { name: '澳大利亚', dial: '+61' },
	// { name: '巴西', dial: '+55' },
	// { name: '比利时', dial: '+32' },
	// { name: '智利', dial: '+56' },
	// { name: '丹麦', dial: '+45' },
	// { name: '德国', dial: '+49' },
	// { name: '俄罗斯', dial: '+7' },
	// { name: '法国', dial: '+33' },
	// { name: '菲律宾', dial: '+63' },
	// { name: '芬兰', dial: '+358' },
	// { name: '韩国', dial: '+82' },
	// { name: '荷兰', dial: '+31' },
	// { name: '吉尔吉斯斯坦', dial: '+996' },
	// { name: '加拿大', dial: '+1' },
	// { name: '柬埔寨', dial: '+855' },
	// { name: '卡塔尔', dial: '+974' },
	// { name: '科威特', dial: '+965' },
	// { name: '老挝', dial: '+856' },
	// { name: '黎巴嫩', dial: '+961' },
	// { name: '美国', dial: '+1' },
	// { name: '孟加拉国', dial: '+880' },
	// { name: '秘鲁', dial: '+51' },
	// { name: '缅甸', dial: '+95' },
	// { name: '摩洛哥', dial: '+212' },
	// { name: '墨西哥', dial: '+52' },
	// { name: '南非', dial: '+27' },
	// { name: '尼泊尔', dial: '+977' },
	// { name: '尼日利亚', dial: '+234' },
	// { name: '挪威', dial: '+47' },
	// { name: '葡萄牙', dial: '+351' },
	// { name: '日本', dial: '+81' },
	// { name: '瑞典', dial: '+46' },
	// { name: '瑞士', dial: '+41' },
	// { name: '沙特阿拉伯', dial: '+966' },
	// { name: '斯里兰卡', dial: '+94' },
	// { name: '突尼斯', dial: '+216' },
	// { name: '土耳其', dial: '+90' },
	// { name: '委内瑞拉', dial: '+58' },
	// { name: '乌克兰', dial: '+380' },
	// { name: '乌拉圭', dial: '+598' },
	// { name: '西班牙', dial: '+34' },
	// { name: '希腊', dial: '+30' },
	// { name: '新西兰', dial: '+64' },
	// { name: '匈牙利', dial: '+36' },
	// { name: '意大利', dial: '+39' },
	// { name: '印度', dial: '+91' },
	// { name: '印度尼西亚', dial: '+62' },
	// { name: '英国', dial: '+44' },
	// { name: '以色列', dial: '+972' },
	// { name: '伊拉克', dial: '+964' },
	// { name: '伊朗', dial: '+98' },
	// { name: '约旦', dial: '+962' },
	// { name: '赞比亚', dial: '+260' },

];

OTHERS.sort((a, b) => a.name.localeCompare(b.name, 'zh-Hans-CN'));

export const PHONE_AREA_CODES = [
	{ name: '中国大陆', dial: '+86' },
	{ name: '中国香港', dial: '+852' },
	{ name: '中国澳门', dial: '+853' },
	{ name: '中国台湾', dial: '+886' },
	{ name: '马来西亚', dial: '+60' },
	{ name: '新加坡', dial: '+65' },
	{ name: '泰国', dial: '+66' },
	{ name: '越南', dial: '+84' },

	...OTHERS
];
